import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "experience" }
const _hoisted_2 = { class: "experience__wrapper" }
const _hoisted_3 = { class: "experience__header" }
const _hoisted_4 = { class: "experience__header title" }
const _hoisted_5 = { class: "experience__header company" }
const _hoisted_6 = { class: "experience__header__subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "experience__header location"
}
const _hoisted_8 = { class: "experience__header periode" }
const _hoisted_9 = { class: "experience__description" }
const _hoisted_10 = ["innerHTML"]

import {FormatHelper} from '@/profile-creation-wizard/common/helpers/FormatHelper';
    import ReadMore from '@/profile-creation-wizard/common/ui/ReadMore.vue';
    import {useTranslation} from '@malt/vue3-use';
    import {computed} from 'vue';
    import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
    import {Experience} from '../../../domain/experience/Experience';

    type ExperienceEditEvent = {
        (e: 'experience:edit', experienceId: Experience['id']): void;
        (e: 'experience:delete', experience: Experience): void;
    };

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Experience',
  props: {
    experience: {}
  },
  emits: ["experience:edit", "experience:delete"],
  setup(__props: any, { emit: __emit }) {

    const {msg} = useTranslation();

    const props = __props;
    const emits = __emit;

    const formattedAddress = computed(() => props.experience.location?.formattedAddress || '');
    const formattedDescription = computed(() => FormatHelper.textToHtmlFormattedText(props.experience.description));
    const formattedStartDate = computed(() => FormatHelper.dateToSimpleDateString(context.locale, props.experience.startDate));
    const formattedEndDate = computed(() => {
        if (props.experience.isCurrentJob === true) {
            return msg('profile.xp.reco.humanize.time.today');
        }

        return FormatHelper.dateToSimpleDateString(context.locale, props.experience.endDate as Date);
    });

    const readMoreLabel = msg('jstext.readmore.label.readmore');

    function handleDelete() {
        emits('experience:delete', props.experience);
    }

    function handleEdit() {
        emits('experience:edit', props.experience.id);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "experience__icon" }, [
      _createElementVNode("joy-icon", {
        name: "company-placeholder",
        size: "large"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(props.experience.title) + " ", 1),
            _createElementVNode("div", { class: "actions" }, [
              _createElementVNode("joy-icon", {
                class: "action delete-icon",
                name: "trash",
                color: "red",
                onClick: handleDelete
              }),
              _createElementVNode("joy-icon", {
                class: "action",
                name: "pen",
                onClick: handleEdit
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(props.experience.company), 1),
          _createElementVNode("div", _hoisted_6, [
            (formattedAddress.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("joy-icon", {
                    name: "location",
                    color: "grey"
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(formattedAddress.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("joy-icon", {
                name: "calendar",
                color: "grey"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(formattedStartDate.value) + " - " + _toDisplayString(formattedEndDate.value), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(ReadMore, {
          "max-height": 100,
          "view-more-label": _unref(readMoreLabel)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", { innerHTML: formattedDescription.value }, null, 8, _hoisted_10)
          ]),
          _: 1
        }, 8, ["view-more-label"])
      ])
    ])
  ]))
}
}

})